import { Select, SelectProps } from '@mantine/core';

const DWELLING_OPTIONS = [
	{ value: 'House', label: 'House' },
	{ value: 'Townhouse', label: 'Townhouse' },
	{ value: 'Apartment/unit', label: 'Apartment/unit' },
	{ value: 'Villa', label: 'Villa' },
	{ value: 'Rural', label: 'Rural' },
	{ value: 'Retirement living', label: 'Retirement living' },
];

export const DwellingInput = (props: SelectProps) => {
	return <Select data={DWELLING_OPTIONS} {...props} />;
};
